import { FC, useEffect, useState } from "react";
import Block from "../components/Block.component";
import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import colors from "../config/Colors.config";
import { IconButton } from "@mui/material";
import { Close, CloudDownloadOutlined, FacebookOutlined, Instagram, WhatsApp } from "@mui/icons-material";

import imgQR from "../assets/icon/imgQR.png";
import imgLogo from "../assets/img/logo.png";
import imgQRCode from "../assets/img/qrCode.svg";
import Device from "../interfaces/Device.interface";
import DeviceConfig from "../config/Device.config";

const IndexPage: FC = () => {

    const [device, setDevice] = useState<Device>(DeviceConfig.data());

    const [isHovered, setIsHovered] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    useEffect(() => {
        const device: Device = DeviceConfig.data();
        setDevice(device);
    }, []);

    return (
        <>
            <section
                style={{
                    backgroundImage: "linear-gradient(to bottom, #e2211c, #e32923, #e42f29, #e4352f, #e53b35, #e6423c, #e84943, #e9504a, #ec5a54, #ef635e, #f26c67, #f47571)",
                    height: "100vh",
                    width: "100%",
                    display: "flex",                  // ← Flexbox
                    justifyContent: "center",         // ← Centrado horizontal
                    alignItems: "center",             // ← Centrado vertical
                    flexDirection: "column"           // ← Para que Block esté arriba si lo necesitas
                }}
            >
                {/* <Block height={"20vh"} /> */}
                <div style={{ width: device.isDesktop ? "35%" : "98%", height: "85vh"/*, border: "2px solid #FFFFFF" */ }} >
                    <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ height: 50, width: 50, backgroundColor: colors.blanco, marginRight: 5 }}
                                onClick={() => {
                                    setIsOpenModal(true);
                                }}
                            >
                                <img style={{ height: 30 }} src={imgQR} alt="No data" />
                            </IconButton>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: 170, width: 170, maxWidth: 170 }} >
                            <img src={imgLogo} alt="No data" style={{ height: 150 }} />
                        </Col>
                        <Col  >
                            <Row>
                                <Label style={{ color: colors.blanco, fontSize: 26, fontWeight: "bold" }} >
                                    Pollo Pérez
                                </Label>
                            </Row>
                            <Row>
                                <Label style={{ color: colors.blanco, fontSize: 16, }} >
                                    Te conquistará el sabor de nuestras ricas variedades de pollo empanizado y complementos.
                                </Label>
                            </Row>
                            <Row>
                                {
                                    device.isDesktop &&
                                    <Col>
                                        <IconButton
                                            style={{ height: 60, width: 60 }}
                                            onClick={() => {
                                                window.open(`https://www.facebook.com/share/1CH9rz9qNu/?mibextid=wwXIfr`, '_blank');
                                            }}
                                        >
                                            <FacebookOutlined style={{ height: 40, width: 40, color: colors.blanco }} />
                                        </IconButton>
                                        <IconButton
                                            style={{ height: 60, width: 60, marginLeft: 15 }}
                                            onClick={() => {
                                                window.open(`https://wa.me/9612127777`, '_blank');
                                            }}
                                        >
                                            <WhatsApp style={{ height: 40, width: 40, color: colors.blanco }} />
                                        </IconButton>
                                        <IconButton
                                            style={{ height: 60, width: 60, marginLeft: 15 }}
                                            onClick={() => {
                                                window.open(`https://www.instagram.com/polloperezchis?igsh=MXJpNnJjbXYybGQ5dg==`, '_blank');
                                            }}
                                        >
                                            <Instagram style={{ height: 40, width: 40, color: colors.blanco }} />
                                        </IconButton>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                    {
                        device.isMovil &&
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 5 }} >
                            <Col>
                                <IconButton
                                    style={{ height: 60, width: 60 }}
                                    onClick={() => {
                                        window.open(`https://www.facebook.com/share/1CH9rz9qNu/?mibextid=wwXIfr`, '_blank');
                                    }}
                                >
                                    <FacebookOutlined style={{ height: 40, width: 40, color: colors.blanco }} />
                                </IconButton>
                                <IconButton
                                    style={{ height: 60, width: 60, marginLeft: 15 }}
                                    onClick={() => {
                                        window.open(`https://wa.me/9612127777`, '_blank');
                                    }}
                                >
                                    <WhatsApp style={{ height: 40, width: 40, color: colors.blanco }} />
                                </IconButton>
                                <IconButton
                                    style={{ height: 60, width: 60, marginLeft: 15 }}
                                    onClick={() => {
                                        window.open(`https://www.instagram.com/polloperezchis?igsh=MXJpNnJjbXYybGQ5dg==`, '_blank');
                                    }}
                                >
                                    <Instagram style={{ height: 40, width: 40, color: colors.blanco }} />
                                </IconButton>
                            </Col>
                        </Row>
                    }
                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 5 }} >
                        <Col>
                            <Button
                                style={{ transition: "transform 0.2s ease", boxShadow: "7px 15px 0 black", width: "100%", borderRadius: 50, height: 50, fontSize: 18, fontWeight: "bold", color: colors.negro, backgroundColor: colors.blanco, borderColor: colors.blanco }}
                                onClick={() => {
                                    window.open(`https://wa.me/9612127777`, '_blank');
                                }}
                            >
                                WHATSAPP
                            </Button>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 25 }} >
                        <Col>
                            <Button
                                style={{ transition: "transform 0.2s ease", boxShadow: "7px 15px 0 black", width: "100%", borderRadius: 50, height: 50, fontSize: 18, fontWeight: "bold", color: colors.negro, backgroundColor: colors.blanco, borderColor: colors.blanco }}
                                onClick={() => {
                                    window.open(`https://www.google.com/maps/place/Pollo+P%C3%A9rez+Calzada+Sumidero+Norte/@16.7733272,-93.1050765,843m/data=!3m2!1e3!4b1!4m6!3m5!1s0x85ecd9abeadf7ab1:0x6a2628d38aecff91!8m2!3d16.7733272!4d-93.1025016!16s%2Fg%2F11wtqzxfnv?entry=ttu&g_ep=EgoyMDI1MDcxNS4xIKXMDSoASAFQAw%3D%3D`, '_blank');
                                }}
                            >
                                UBICACIÓN
                            </Button>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 25, }} >
                        <Col>
                            <Button
                                style={{ cursor: "pointer", transition: "transform 0.2s ease", boxShadow: "7px 15px 0 black", width: "100%", borderRadius: 30, height: 100, color: colors.negro, backgroundColor: colors.blanco, borderColor: colors.blanco }}
                                onClick={() => {
                                    window.open(`https://wa.me/c/5219612127777`, '_blank');
                                }}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                            >
                                <div style={{ cursor: "pointer" }}>
                                    <Row style={{ cursor: "pointer" }} >
                                        <Label style={{ fontWeight: "bold", fontSize: 20, cursor: "pointer", textDecorationLine: isHovered ? "underline" : "" }} >
                                            MENÚ
                                        </Label>
                                    </Row>
                                    <Row style={{ cursor: "pointer" }} >
                                        <Label style={{ fontSize: 14, cursor: "pointer", textDecorationLine: isHovered ? "underline" : "" }} >
                                            Menú de Calzada Sumidero Norte
                                        </Label>
                                    </Row>
                                    <Row style={{ cursor: "pointer" }} >
                                        <Label style={{ fontSize: 14, cursor: "pointer", textDecorationLine: isHovered ? "underline" : "" }} >
                                            Ordenar
                                        </Label>
                                    </Row>
                                </div>
                            </Button>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 25 }} >
                        <Col>
                            <Button
                                style={{ transition: "transform 0.2s ease", boxShadow: "7px 15px 0 black", width: "100%", borderRadius: 50, height: 50, fontSize: 18, fontWeight: "bold", color: colors.negro, backgroundColor: colors.blanco, borderColor: colors.blanco }}
                                onClick={() => {
                                    window.location.href = "tel:9612127777"
                                }}
                            >
                                ☎️LLAMANOS
                            </Button>
                        </Col>
                    </Row>
                </div>
            </section >

            <Modal
                isOpen={isOpenModal}
                centered
            >
                <ModalHeader
                    style={{ backgroundImage: "linear-gradient(to bottom, #e2211c, #e3241f, #e52722, #e62a25, #e72d28, #e8302b, #ea332d, #eb3630, #ec3933, #ee3c37, #ef3f3a, #f0423d)", }}
                    close={
                        <IconButton
                            style={{ backgroundColor: colors.blanco, color: colors.negro }}
                            onClick={() => setIsOpenModal(false)}
                        >
                            <Close />
                        </IconButton>
                    }
                >

                </ModalHeader >
                <ModalBody>
                    <Row>
                        <Col style={{ textAlign: "center" }} >
                            <img src={imgQRCode} alt="No data" style={{ height: "30vh" }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                style={{ borderRadius: 12, boxShadow: "none", backgroundColor: colors.blanco, border: `solid 2px ${colors.negro}`, color: colors.negro, fontWeight: "bold", width: "100%" }}
                                onClick={() => {
                                    const enlace = document.createElement("a");
                                    enlace.href = imgQRCode; // ruta ya procesada por el bundler
                                    enlace.download = "logo.svg"; // nombre con el que se descargará
                                    document.body.appendChild(enlace);
                                    enlace.click();
                                    document.body.removeChild(enlace);
                                }}
                            >
                                <CloudDownloadOutlined /> Descargar QR
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ boxShadow: "none", backgroundColor: colors.amarillo01, borderColor: "transparent", color: colors.negro, fontWeight: "bold" }}
                        onClick={() => setIsOpenModal(false)}
                    >
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal >

        </>
    );

};



export default IndexPage;